













































































































import { Component, Vue } from "vue-property-decorator";
import {
  BudgetUnitEnum,
  ProjectEditModel,
  ProjectStaffAppUserViewModel,
  ProjectStaffEditModel,
  RateRuleAmountFilter
} from "@/services/api/nswag/stapiclient_generated";
import { projectStaffApi, stProjectApi } from "@/services/st-api";
import { UserStore } from "@/store/user-module";
import StRatePicker from "@/components/basic/StRatePicker.vue";
import SlideIn from "@/components/basic/SlideIn.vue";
import StInput2 from "@/components/basic/StInput2.vue";
import StToggle from "@/components/basic/StToggle.vue";
import ProjectProjectTaskEditList from "@/views/Projects/ProjectProjectTaskEditList.vue";
import ProjectStaffEdit from "@/views/Projects/ProjectStaffEdit.vue";
import { TabModel } from "@/components/tabs/tab-model";
import StTabs from "@/components/tabs/StTabs.vue";
import { notifySuccess } from "@/utlitities/notifications";
import StPercentInput from "@/components/basic/StPercentInput.vue";
import StDatePicker from "@/components/basic/StDatePicker.vue";
import StCurrencyInput from "@/components/basic/StCurrencyInput.vue";
import ProjectChangeFixedPriceWarning from "@/views/Projects/ProjectChangeFixedPriceWarning.vue";
import EditCustomerProject from "@/views/Projects/EditCustomerProject.vue";

@Component({
  components: {
    EditCustomerProject,
    ProjectChangeFixedPriceWarning,
    StCurrencyInput,
    StDatePicker,
    ProjectStaffEdit,
    ProjectProjectTaskEditList,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
    StTabs,
    StPercentInput
  }
})
export default class EditProject extends Vue {
  private customerid: number = 0;
  private projectid: number = 0;
  private project: ProjectEditModel = ProjectEditModel.fromJS({ customerId: 0, name: "", amountModel: {} });
  private listPage = "Projects";
  private loading: boolean = true;
  private saving: boolean = false;
  appUsers: ProjectStaffAppUserViewModel[] = [];
  isReadonly: boolean = false;

  allEmployeesAllowed: boolean = true;

  activeTabName = "standard";

  get tabs(): TabModel[] {
    let res = [
      {
        TabName: "standard",
        Disabled: false
      }
    ];

    if (this.appUsers.length) {
      res.push({
        TabName: "rights",
        Disabled: false
      });
    }

    return res;
  }

  get projectStaffEditModels() {
    return this.project.projectStaff ?? [];
  }

  set projectStaffEditModels(data: ProjectStaffEditModel[]) {
    this.project.projectStaff = data;
  }

  get useFixedPriceProjects(){
    return UserStore.userSettings.useFixedPriceProjects;
  }

  get useCustomerProjectId() {
    return UserStore.userSettings.featureFlagCustomerProjectId;
  }

  checkAllSelected() {
    if (this.allEmployeesAllowed) {
      this.projectStaffEditModels = [];
    }
  }

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  created() {
    this.customerid = parseInt(this.$route.params.customerid);
    this.projectid = parseInt(this.$route.params.projectid);
    this.isReadonly = !!this.$route.params.readonly;
  }

  async mounted() {
    this.openSlideIn();

    this.appUsers = await projectStaffApi.getEmployees(this.projectid);
    this.project = this.projectid == 0 ? await stProjectApi.getNew(this.customerid) : await stProjectApi.get(this.projectid);
    this.allEmployeesAllowed = !this.projectStaffEditModels.length;

    this.loading = false;
  }

  setThresholdIfZero() {
    if (this.project.notifyOnBudgetOverrun && this.project.budgetOverrunThresholdPercent == 0) {
      this.project.budgetOverrunThresholdPercent = 100;
    }
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get rateRuleAmountFilter() {
    return RateRuleAmountFilter.fromJS({
      customerId: this.customerid,
      projectId: this.projectid,
      projectTaskId: undefined,
      appUserId: undefined
    });
  }

  get budgetUnitOptions() {
    return [
      { id: "Currency", description: UserStore.userSettings.currency, disabled: UserStore.userSettings.noRates },
      { id: "Hours", description: "h (alle)" },
      { id: "HoursBillable", description: "h (verrechenbar)" }
    ];
  }

  get budgetTimeFrameOptions() {
    return [{ id: "Fixed", description: "fixes Budget" }];
  }

  get budgetInputType() {
    if (this.project.budgetUnit == BudgetUnitEnum.Hours) {
      return "duration";
    }

    return "currency";
  }

  get useRateRules() {
    return UserStore.userSettings.useRateRules;
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  async submit() {
    try {
      this.saving = true;
      this.project.allowDeleteDependentEntitiesForProjectTasks = true;
      if (this.project.id == 0) {
        await stProjectApi.post(this.project);
      } else {
        await stProjectApi.put(this.project.id, this.project);
      }
      notifySuccess("Erfolgreich gespeichert");

      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }

  abort() {
    this.closeSlideIn();
  }
}
